export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CaregiverRoleEnum_AllergyDoctor": "Lægen",
	"CaregiverRoleEnum_Dentist": "Tannlege",
	"CaregiverRoleEnum_Dermatologist": "Hudlegen",
	"CaregiverRoleEnum_Doctor": "Fastlegen",
	"CaregiverRoleEnum_Midwife": "Jordmor",
	"CaregiverRoleEnum_Nurse": "Helsesøster",
	"CaregiverRoleEnum_Physiotherapist": "Fysioterapeuten",
	"CaregiverRoleEnum_Psychologist": "Psykologen",
	"CaregiverRoleEnum_Rheumatologist": "Reumatologer",
	"CaregiverRoleEnum_SundVaegtDoctor": "HealthyWeight-legen",
	"CaregiverRoleEnum_SundVaegtNurse": "HealthyWeight-sykepleieren",
	"CaregiverRoleEnum_Dietitian": "Kostholdseksperten",
	"CaregiverRoleEnum_AcneDermatologist": "Hudlegen",
	"CaregiverRoleEnum_Veterinarian": "Dyrlege",
	"CaregiverRoleEnum_AllergyDoctor_Indefinite": "Læge",
	"CaregiverRoleEnum_Dentist_Indefinite": "Tannlege",
	"CaregiverRoleEnum_Dermatologist_Indefinite": "Hudlege",
	"CaregiverRoleEnum_Doctor_Indefinite": "Fastlege",
	"CaregiverRoleEnum_Midwife_Indefinite": "Jordmor",
	"CaregiverRoleEnum_Nurse_Indefinite": "Helsesøster",
	"CaregiverRoleEnum_Physiotherapist_Indefinite": "Fysioterapeut",
	"CaregiverRoleEnum_Psychologist_Indefinite": "Psykolog",
	"CaregiverRoleEnum_Rheumatologist_Indefinite": "Reumatologer",
	"CaregiverRoleEnum_SundVaegtDoctor_Indefinite": "HealthyWeight-lege",
	"CaregiverRoleEnum_SundVaegtNurse_Indefinite": "HealthyWeight-sykepleiere",
	"CaregiverRoleEnum_Dietitian_Indefinite": "Kostholdsekspert",
	"CaregiverRoleEnum_AcneDermatologist_Indefinite": "Hudlege",
	"CaregiverRoleEnum_Veterinarian_Indefinite": "Dyrlege",
	"CaregiverSpecialization_ClinicalPsychologist": "Klinisk psykolog",
	"CaregiverSpecialization_FamilyTherapy": "Familieterapi",
	"CaregiverSpecialization_SundVaegt": "HealthyWeight",
	"CaregiverSpecialization_Pediatric": "Pediatri",
	"ConsultationPaymentProviderEnum_ApplePay": "App Store",
	"ConsultationPaymentProviderEnum_Company": "Foretagende",
	"ConsultationPaymentProviderEnum_Coupon": "Kupong",
	"ConsultationPaymentProviderEnum_DIBS": "Én konsultasjon",
	"ConsultationPaymentProviderEnum_ePay": "Én konsultasjon",
	"ConsultationPaymentProviderEnum_GoogleWallet": "Google Play",
	"ConsultationPaymentProviderEnum_GracePeriod": "Gratis svar",
	"ConsultationPaymentProviderEnum_ReepayCheckout": "Én konsultasjon",
	"ConsultationPaymentProviderEnum_Repay": "Én konsultasjon",
	"ConsultationPaymentProviderEnum_Subscription": "Abonnement",
	"ConsultationPaymentProviderEnum_PriceOverride": "-",
	"ConsultationCategoryFilterEnum_Video": "Video",
	"ConsultationCategoryFilterEnum_Text": "Tekst",
	"ConsultationTypeEnum_AllergyCheckVideo": "Allergisjekk",
	"ConsultationTypeEnum_DentistMessage": "Tekstkonsultasjon - tannlege",
	"ConsultationTypeEnum_DentistVideo": "Videokonsultasjon - tannlege",
	"ConsultationTypeEnum_DermatologistMessage": "Tekstkonsultasjon - hudlege",
	"ConsultationTypeEnum_DermatologistVideo": "Videokonsultasjon - hudlege",
	"ConsultationTypeEnum_Message": "Tekstkonsultasjon - lege",
	"ConsultationTypeEnum_MidwifeMessage": "Tekstkonsultasjon - jordmor",
	"ConsultationTypeEnum_MidwifeVideo": "Videokonsultasjon - jordmor",
	"ConsultationTypeEnum_NurseMessage": "Tekstkonsultasjon - helsesøster",
	"ConsultationTypeEnum_NurseVideo": "Videokonsultasjon - helsesøster",
	"ConsultationTypeEnum_PhysiotherapistStartupVideo": "Videokonsultasjon - fysioterapeut oppstart",
	"ConsultationTypeEnum_PhysiotherapistMessage": "Tekstkonsultasjon - fysioterapeut",
	"ConsultationTypeEnum_Prescription": "Fornyelse av resept",
	"ConsultationTypeEnum_PsychologistVideo": "Videokonsultasjon - psykolog",
	"ConsultationTypeEnum_PsychologistCrisisVideo": "Videokonsultasjon - krisepsykolog",
	"ConsultationTypeEnum_PsychologistFamilyTherapyVideo": "Familieterapi",
	"ConsultationTypeEnum_RheumatologistVideo": "Videokonsultasjon - revmatolog",
	"ConsultationTypeEnum_SundVaegtStartupMessage": "HealthyWeight oppstart",
	"ConsultationTypeEnum_SundVaegtNurseCheckupVideo": "Sunn vektkontroll",
	"ConsultationTypeEnum_Video": "Videokonsultasjon - lege",
	"ConsultationTypeEnum_DietitianStartupVideo": "Videokonsultasjon - oppstart av kostholdsekspert",
	"PlanInterval_Day": "Daglig",
	"PlanInterval_Month": "Månedlig",
	"PlanInterval_Week": "Ukentlig",
	"PlanInterval_Year": "Årlig",
	"ServiceTypeEnum_AllergyCheck": "Allergisjekk: Videokonsultasjon",
	"ServiceTypeEnum_DermatologistMessage": "Hudlege: Tekstkonsultasjon",
	"ServiceTypeEnum_DermatologistMessageReply": "Hudlege: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_DermatologistVideo": "Hudlege: Videokonsultasjon",
	"ServiceTypeEnum_Message": "Lege: Tekstkonsultasjon",
	"ServiceTypeEnum_MessageReply": "Lege: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_PhysiotherapistStartupVideo": "Fysioterapeut: Oppstart av videokonsultasjon",
	"ServiceTypeEnum_PhysiotherapistMessage": "Fysioterapeut: Tekstkonsultasjon",
	"ServiceTypeEnum_PhysiotherapistMessageReply": "Fysioterapeut: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_Prescription": "Lege: Fornyelse av resept",
	"ServiceTypeEnum_PsychologistVideo": "Psykolog: Videokonsultasjon",
	"ServiceTypeEnum_PsychologistCrisisVideo": "Krisepsykolog: Videokonsultasjon",
	"ServiceTypeEnum_PsychologistFamilyTherapyVideo": "Familieterapeut: Videokonsultasjon",
	"ServiceTypeEnum_RheumatologistVideo": "Revmatolog: Videokonsultasjon",
	"ServiceTypeEnum_SundVaegtStartupMessage": "HealthyWeight oppstart",
	"ServiceTypeEnum_VideoConsultation": "Lege: Videokonsultasjon",
	"ServiceTypeEnum_AllergyCheckVideo": "Allergisjekk",
	"ServiceTypeEnum_DietitianStartupVideo": "Kostholdsekspert: Oppstart av videokonsultasjon",
	"UserTypeEnum_Admin": "Administrator",
	"UserTypeEnum_Doctor": "Behandler",
	"UserTypeEnum_Patient": "Pasient",
	"ConsultationTypeEnum_SundVaegtDoctorCheckupVideo": "HealthyWeight lege: Videokonsultasjon",
	"ServiceTypeEnum_SundVaegtDoctorCheckupVideo": "HealthyWeight lege: Videokonsultasjon",
	"ServiceTypeEnum_SundVaegtNurseCheckupVideo": "HealthyWeight sykepleier: Videokontroll",
	"ConsultationTypeEnum_SundVaegtNurseCheckupMessage": "HealthyWeight Nurse: Tekstkonsultasjon",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessage": "HealthyWeight Nurse: Tekstkonsultasjon",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessageReply": "HealthyWeight sykepleier: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessageReply": "HealthyWeight spørreskjema: Svar",
	"ConsultationTypeEnum_SundVaegtNurseAdHocVideo": "Sunn vektkontroll",
	"ServiceTypeEnum_SundVaegtNurseAdHocVideo": "HealthyWeight sykepleier: Videokonsultasjon",
	"ConsultationTypeEnum_SundVaegtQuestionnaireMessage": "HealthyWeight spørreskjema",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessage": "HealthyWeight spørreskjema",
	"ConsultationTypeEnum_PhysiotherapistCheckupVideo": "Videokonsultasjon - fysioterapeut",
	"ServiceTypeEnum_PhysiotherapistCheckupVideo": "Fysioterapeut: Videokonsultasjon",
	"ConsultationTypeEnum_PhysiotherapistQuestionnaireMessage": "Spørreskjema til fysioterapeut",
	"ServiceTypeEnum_PhysiotherapistQuestionnaireMessage": "Fysioterapeut: spørreskjema",
	"ServiceTypeEnum_SundVaegtStartupMessageReply": "HealthyWeight oppstart: Svar",
	"SubscriptionStatusEnum_Active": "Aktiv",
	"SubscriptionStatusEnum_Canceled": "Afmeldt",
	"SubscriptionStatusEnum_Expired": "Udløbet",
	"SubscriptionStatusEnum_PastDue": "Skyldig",
	"SubscriptionStatusEnum_Trialing": "Gratis prøve",
	"SubscriptionStatusEnum_Unknown": "Ukjent",
	"ConsultationTypeEnum_DietitianCheckupVideo": "Videokonsultasjon - kostholdsekspert oppfølging",
	"ServiceTypeEnum_DietitianCheckupVideo": "Kostholdsekspert: Oppfølging av videokonsultasjon",
	"ConsultationTypeEnum_DietitianUploadAttachmentMessage": "Send filer til ernæringsfysiolog",
	"ServiceTypeEnum_DietitianUploadAttachmentMessage": "Ernæringsfysiolog: last opp vedlegg",
	"ServiceTypeEnum_DietitianVideo": "Kostholdsekspert: Videokonsultasjon",
	"AllergyCheckVideo": "Allergisjekk",
	"ConsultationTypeEnum_AllergyCheck": "Allergisjekk",
	"ConsultationTypeEnum_PersonalHealthProgrammeStartup": "Starte et personlig helseprogram",
	"ServiceTypeEnum_PersonalHealthProgrammeStartup": "Starte et personlig helseprogram",
	"ConsultationTypeEnum_AcneProgrammeStartupMessage": "Oppstart av aknekurs",
	"ConsultationTypeEnum_AcneProgrammeStartupVideo": "Oppstart av aknekurs video",
	"ConsultationTypeEnum_AcneProgrammeCheckupVideo": "Oppfølging av video om aknekurs",
	"ServiceTypeEnum_AcneProgrammeStartupMessage": "Oppstart av aknekurs",
	"ServiceTypeEnum_AcneProgrammeStartupVideo": "Oppstart av aknekurs video",
	"ServiceTypeEnum_AcneProgrammeCheckupVideo": "Oppfølging av video om aknekurs",
	"ConsultationTypeEnum_AcneDermatologistMessage": "Tekstkonsultasjon - hudlege",
	"ServiceTypeEnum_AcneDermatologistMessage": "Hudlege: Tekstkonsultasjon",
	"ServiceTypeEnum_AcneDermatologistMessageReply": "Hudlege: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_VeterinarianVideo": "Veterinær: Videokonsultasjon",
	"ConsultationPaymentProviderEnum_Free": "Gratis",
	"ConsultationPaymentProviderEnum_CreatedByCaregiver": "Oprettet af behandler",
	"ConsultationTypeEnum_VeterinarianVideo": "Videokonsultasjon – veterinær",
	"PetSex_Female": "Hun",
	"PetSex_FemaleSterilized": "Sterilisert kvinne",
	"PetSex_Male": "Han",
	"PetSex_MaleNeutered": "Kastrert hann",
	"PetSex_Unknown": "Ukjent",
	"PetType_Dog": "Hund",
	"PetType_Cat": "Kat",
	"PetType_Rabbit": "Kanin",
	"PetType_Rodent": "Gnaver",
	"ReferralOptionEnum_SpecialistsAndPrivateHospitals": "Spesialister og private sykehus",
	"ReferralOptionEnum_Physiotherapy": "Fysioterapi",
	"ReferralOptionEnum_Psychologist": "Psykolog",
	"VetConsultationReasonEnum_Gastrointestinal": "Gastrointestinal",
	"VetConsultationReasonEnum_SkinCoatEars": "Hud, pels og ører (inkl. sår og analkjertler)",
	"VetConsultationReasonEnum_Poisoning": "Forgiftning",
	"VetConsultationReasonEnum_Eyes": "Øyne",
	"VetConsultationReasonEnum_UrinaryTract": "Urinveier",
	"VetConsultationReasonEnum_Lameness": "Halthet",
	"VetConsultationReasonEnum_RespiratoryTract": "Luftveier",
	"VetConsultationReasonEnum_OralCavity": "Munnhule og tenner",
	"VetConsultationReasonEnum_Pain": "Smerte/feber/nedstemthet",
	"VetConsultationReasonEnum_Claws": "Klør",
	"VetConsultationReasonEnum_GenitalsMammaryGlands": "Genitalier og melkekjertler",
	"VetConsultationReasonEnum_ReproductionCycle": "Reproduksjon og syklus",
	"VetConsultationReasonEnum_Behaviour": "Atferd",
	"VetConsultationReasonEnum_Prescription": "Resept",
	"VetConsultationReasonEnum_OtherReason": "Annet",
	"VetConsultationOutcomeEnum_AdvisedForHomeTreatment": "Rådet til behandling hjemme (inkludert tilfeller som ikke krever behandling)",
	"VetConsultationOutcomeEnum_ReferredDuringRegularOpeningHours": "Henvist i vanlig åpningstid",
	"VetConsultationOutcomeEnum_ReferredOutsideRegularOpeningHours": "Henvist utenom vanlig åpningstid",
	"PhysioConsultationOutcomeEnum_ConservativeApproachPatientContinuesAlone": "Konservativ tilnærming, pasienten fortsetter på egen hånd",
	"PhysioConsultationOutcomeEnum_OfferedFollowUpConsultation": "Tilbudt oppfølgingskonsultasjon (konservativ tilnærming)",
	"PhysioConsultationOutcomeEnum_ReturnedToVisitationForPhysicalTreatment": "Sendt tilbake til visitasjon for fysisk behandling",
	"PhysioConsultationOutcomeEnum_ReturnedToOwnDoctor": "Sendt tilbake til egen lege",
	"PhysioConsultationOutcomeEnum_NoShow": "Uteblivelse",
	"ConsultationTypeEnum_DynamicCodeVideo": "Videokonsultasjon - Dynamic Code",
	"ServiceTypeEnum_DynamicCodeVideo": "Videokonsultasjon - Dynamic Code",
	"ServiceTypeEnum_NurseVideo": "Sundhedsplejerske: video",
	"ServiceTypeEnum_MidwifeVideo": "Jordemoder: video",
	"ServiceTypeEnum_NurseMessage": "Helsesøster: Tekstkonsultasjon",
	"ServiceTypeEnum_NurseMessageReply": "Helsesøster: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_MidwifeMessage": "Jordmor: Tekstkonsultasjon",
	"ServiceTypeEnum_MidwifeMessageReply": "Jordmor: Svar på tekstkonsultasjon",
	"ConsultationTypeEnum_VeterinarianMessage": "Tekstkonsultasjon – veterinær",
	"ServiceTypeEnum_VeterinarianMessage": "Veterinær: Tekstkonsultasjon",
	"ServiceTypeEnum_VeterinarianMessageReply": "Veterinær: Svar på tekstkonsultasjon",
	"VetConsultationOutcomeEnum_RequestedMoreInformation": "Be om mer informasjon (eller bestill en ny videokonsultasjon)",
	"ConsultationTypeEnum_PracticeManagerMessage": "Anden henvendelse",
	"CaregiverRoleEnum_PracticeManager_Indefinite": "Praksismanager",
	"ServiceTypeEnum_PracticeManagerMessage": "Anden henvendelse",
	"CaregiverRoleEnum_PracticeManager": "Praksismanageren",
	"ConsultationTypeEnum_PsychologistMessage": "Psykolog: Tekstkonsultation",
	"ServiceTypeEnum_PsychologistMessage": "Psykolog: Tekstkonsultation",
	"SubscriptionStatusEnum_OnHold": "På pause",
	"ReferralType_Physiotherapy": "Fysioterapihenvisning",
	"ReferralType_Hospital": "Sykehushenvisning",
	"ReferralType_Psychologist": "Psykologhenvisning",
	"ReferralType_Specialist": "Spesialisthenvisning",
	"SpecialistVisitationOptionsEnum_InternMedicine": "Intern medisin",
	"SpecialistReferralCode_TreatmentAndInvestigation": "Utredning og behandling",
	"SpecialistReferralCode_Radiology": "Radiologi",
	"SpecialistReferralCode_ContinuedTreatment": "Fortsatt behandling",
	"SpecialistReferralCode_Visit": "Besøk",
	"SpecialistReferralCode_SingleConsultationAssessment": "Vurdering ved enkeltstående konsultasjon",
	"HospitalCallPriority_Urgent": "akut",
	"HospitalCallPriority_Elective": "elektiv",
	"HospitalStatus_Outpatient": "ambulant",
	"HospitalStatus_Admission": "indlæggelse",
	"HospitalTransport_None": "ingen",
	"HospitalTransport_Seated": "siddende",
	"HospitalTransport_Lying": "liggende",
	"PsychologyDiagnosis_RobberyViolenceOrRapeVictim": "Ran-, volds- eller voldtektsoffer",
	"PsychologyDiagnosis_TrafficOrAccidentVictim": "Trafikk eller ulykkeoffer",
	"PsychologyDiagnosis_RelativesOfSeriouslyMentallyIllPersons": "Pårørende til alvorlig psykisk syke personer",
	"PsychologyDiagnosis_PersonsAffectedBySeriousDisablingDisease": "Personer rammet av alvorlig invalidiserende sykdom",
	"PsychologyDiagnosis_RelativesOfPersonsAffectedBySeriousDisablingDisease": "Pårørende til personer rammet av alvorlig invalidiserende sykdom",
	"PsychologyDiagnosis_RelativesInCaseOfDeath": "Pårørende ved dødsfall",
	"PsychologyDiagnosis_PersonsWhoHaveAttemptedSuicide": "Personer som har forsøkt selvmord",
	"PsychologyDiagnosis_WomenUndergoingAbortionAfter12WeeksOfPregnancy": "Kvinner som får utført abort etter 12. svangerskapsuke",
	"PsychologyDiagnosis_PersonsUnder18WhoHaveBeenVictimsOfIncestOrOtherSexualAbuse": "Personer som før fylte 18 år har vært ofre for incest eller andre seksuelle overgrep",
	"PsychologyDiagnosis_PersonsWithMildToModerateDepressionAfterPsychometricTest": "Personer med lett til moderat depresjon, etter utført psykometrisk test (fra 18 år)",
	"PsychologyDiagnosis_PersonsWithMildToModerateAnxietyIncludingMildToModerateOCD": "Personer med lett til moderat angst, herunder lett til moderat OCD (fra 18 år)",
	"PsychologyDiagnosis_DeviationFrom6Months": "Avvik fra 6 mnd. fristen (kort begrunnelse)",
	"ServiceTypeEnum_NnStartupVideo": "SundVægtSammen: Opstartsvideo",
	"ServiceTypeEnum_NnNurseCheckupVideo": "SundVægtSammen: Opfølgende video med SundVægt-sygeplejerske",
	"ServiceTypeEnum_NnDietitianCheckupVideo": "SundVægtSammen: Opfølgende video med diætist",
	"ServiceTypeEnum_NnDoctorMessage": "SundVægtSammen: Besked til SundVægt læge",
	"ServiceTypeEnum_NnDoctorMessageReply": "SundVægtSammen: Svar fra SundVægt læge",
	"ServiceTypeEnum_NnScreeningQuestionnaireMessage": "SundVægtSammen: Screening spørgeskema",
	"ServiceTypeEnum_NnOnboardingQuestionnaireMessage": "SundVægtSammen: Onboarding spørgeskema",
	"ServiceTypeEnum_NnCheckupQuestionnaireMessage": "SundVægtSammen: Opfølgende spørgeskema",
	"ServiceTypeEnum_NnExitQuestionnaireMessage": "SundVægtSammen: Afsluttende spørgeskema",
	"ServiceTypeEnum_SundVaegtExitQuestionnaireMessage": "SundVægt: Avsluttende spørreskjema",
	"ConsultationTypeEnum_NnStartupVideo": "SundVægtSammen opstartsvideo",
	"ConsultationTypeEnum_NnNurseCheckupVideo": "SundVægtSammen opfølgende video med sygeplejerske",
	"ConsultationTypeEnum_NnDietitianCheckupVideo": "SundVægtSammen opfølgende video med diætist",
	"ConsultationTypeEnum_NnDoctorMessage": "SundVægtSammen besked til læge",
	"ConsultationTypeEnum_NnScreeningQuestionnaireMessage": "SundVægtSammen screening spørgeskema",
	"ConsultationTypeEnum_NnOnboardingQuestionnaireMessage": "SundVægtSammen onboarding spørgeskema",
	"ConsultationTypeEnum_NnCheckupQuestionnaireMessage": "SundVægtSammen opfølgende spørgeskema",
	"ConsultationTypeEnum_NnExitQuestionnaireMessage": "SundVægtSammen afsluttende spørgeskema",
	"ConsultationTypeEnum_SundVaegtExitQuestionnaireMessage": "SundVægt avsluttende spørreskjema",
	"ConsultationTypeEnum_SundVaegtFeedbackQuestionnaireMessage": "SundVægt tilbakemeldingsskjema",
	"ServiceTypeEnum_SundVaegtFeedbackQuestionnaireMessage": "SundVægt: tilbakemeldingsskjema",
	"HospitalPriorityOptionsEnum_Urgent": "Akutt",
	"HospitalPriorityOptionsEnum_Elective": "Elektiv",
	"HospitalTransportOptionsEnum_None": "Ingen",
	"HospitalTransportOptionsEnum_Seated": "Sittende",
	"HospitalTransportOptionsEnum_Lying": "Liggende",
	"HospitalStatusOptionsEnum_Admission": "Innleggelse",
	"HospitalStatusOptionsEnum_Outpatient": "Poliklinisk",
	"ConsultationPaymentProviderEnum_HouseholdAccess": "Husstandsadgang",
	"ServiceTypeEnum_MenopauseStartupVideo": "SundOvergang: opstartskonsultation med læge",
	"ServiceTypeEnum_MenopauseNurseCheckupVideo": "SundOvergang: opfølgende video med sygeplejerske",
	"ServiceTypeEnum_MenopauseNurseMessage": "SundOvergang: tekstkonsultation",
	"ServiceTypeEnum_MenopauseNurseMessageReply": "SundOvergang: svar på tekstkonsultation",
	"ConsultationTypeEnum_MenopauseStartupVideo": "SundOvergang: opstartskonsultation med læge",
	"ConsultationTypeEnum_MenopauseNurseCheckupVideo": "SundOvergang: opfølgende video med sygeplejerske",
	"ConsultationTypeEnum_MenopauseNurseMessage": "SundOvergang: tekstkonsultation",
	"ConsultationTypeEnum_MenopauseOffboardingVideo": "SundOvergang: afsluttende konsultation med læge",
	"ServiceTypeEnum_MenopauseOffboardingVideo": "SundOvergang: afsluttende konsultation med læge",
	"CaregiverRoleEnum_Gynecologist": "Gynækologen",
	"CaregiverRoleEnum_MenopauseDoctor": "SundOvergang legen",
	"CaregiverSpecialization_Menopause": "Overgangsalder",
	"CaregiverRoleEnum_Gynecologist_Indefinite": "Gynækolog",
	"CaregiverRoleEnum_MenopauseDoctor_Indefinite": "SundOvergang lege",
	"ConsultationTypeEnum_DietitianMessage": "Tekstkonsultasjon - ernæringsfysiolog",
	"ServiceTypeEnum_DietitianMessage": "Ernæringsfysiolog: Tekstkonsultasjon",
	"ServiceTypeEnum_DietitianMessageReply": "Ernæringsfysiolog: Svar på tekstkonsultasjon",
	"EpicrisisDocumentType_DischargeLetter": "Utskrivningsbrev",
	"EpicrisisDocumentType_OutPatientDischargeLetter": "Poliklinisk utskrivningsbrev",
	"EpicrisisDocumentType_CasualtyWardLetter": "Akuttmottaksbrev",
	"EpicrisisDocumentType_RadiologyReport": "Røntgenbeskrivelse",
	"EpicrisisDocumentType_PrivateSpecialistLetter": "Privatspesialistbrev",
	"ConsultationTypeEnum_MenopauseDietitianVideo": "SundOvergang: videokonsultation med diætist",
	"ServiceTypeEnum_MenopauseDietitianVideo": "SundOvergang: videokonsultation med diætist",
	"ServiceTypeEnum_MenopauseHalfwayVideo": "SundOvergang: midtvejskonsultation med læge",
	"ConsultationTypeEnum_MenopauseHalfwayVideo": "SundOvergang: midtvejskonsultation med læge",
	"AuditProblemCategory_IncorrectDiagnosis": "Feil diagnose",
	"AuditProblemCategory_InsufficientTreatment": "Utilstrekkelig behandling",
	"AuditProblemCategory_MedicationError": "Medisineringsfeil",
	"AuditProblemCategory_DocumentationError": "Dokumentasjonsfeil",
	"AuditProblemCategory_CommunicationIssue": "Kommunikasjonsproblem",
	"AuditProblemCategory_OtherIssue": "Annet",
	"PhysioConsultationOutcomeEnum_OfferedVideoConsultation": "Tilbudt videokonsultation",
	"PhysioConsultationOutcomeEnum_NeedMoreInformation": "Brug for mere information",
	"CaregiverRoleEnum_Doctor_Plural": "Fastleger",
	"CaregiverRoleEnum_Nurse_Plural": "Helsesøstre",
	"CaregiverRoleEnum_Dentist_Plural": "Tannleger",
	"CaregiverRoleEnum_Midwife_Plural": "Jordmødre",
	"CaregiverRoleEnum_Dermatologist_Plural": "Hudleger",
	"CaregiverRoleEnum_Rheumatologist_Plural": "Revmatologer",
	"CaregiverRoleEnum_Physiotherapist_Plural": "Fysioterapeuter",
	"CaregiverRoleEnum_Psychologist_Plural": "Psykologer",
	"CaregiverRoleEnum_AllergyDoctor_Plural": "Leger",
	"CaregiverRoleEnum_SundVaegtDoctor_Plural": "HealthyWeight-leger",
	"CaregiverRoleEnum_SundVaegtNurse_Plural": "HealthyWeight-sykepleiere",
	"CaregiverRoleEnum_Dietitian_Plural": "Kostholdseksperter",
	"CaregiverRoleEnum_AcneDermatologist_Plural": "Hudleger",
	"CaregiverRoleEnum_Veterinarian_Plural": "Dyrleger",
	"CaregiverRoleEnum_PracticeManager_Plural": "Praksismanagere",
	"CaregiverRoleEnum_Gynecologist_Plural": "Gynekologer",
	"CaregiverRoleEnum_MenopauseDoctor_Plural": "SundOvergang-leger"
}